export const RECEIVE_MY_LINK = "RECEIVE_MY_LINK"
export const DELETE_LINK = "DELETE_LINK"
export const ADD_LINK = "ADD_LINK"
export const UPDATE_LINK = "UPDATE_LINK"
export const MOVE_LINK = "MOVE_LINK"
export const DROP_LINK = "DROP_LINK"
export const CHANGE_SAVE_STATUS = "CHANGE_SAVE_STATUS"
export const AFTER_SAVE = "AFTER_SAVE"
